import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";

import { pathNovaZadost, pathUpravitZadost } from "./zadost-pripsani-bodu-zahranicni-souteze/routes-path";
import ZadostPripsaniBoduZahrSout from "./zadost-pripsani-bodu-zahranicni-souteze/ZadostPripsaniBoduZahrSout";

class Pary extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        const pathRedirect = "/";

        return <Switch>
            <Route path={pathNovaZadost} render={(routeProps) => <ZadostPripsaniBoduZahrSout />} />
            <Route path={pathUpravitZadost} render={(routeProps) => <ZadostPripsaniBoduZahrSout />} />


            <Redirect to={pathRedirect} />
        </Switch>;

    }
}

export default withRouter(Pary);